/**
 * A factory function that generates a unique ID with each call.
 * @param {number} initialValue - The initial value of the ID. Defaults to 0.
 * @returns {function} - A function that, when called, returns the next ID.
 */
export const nextIdFactory = (initialValue = 0) => {
  // Initialize the ID with the provided initial value
  let id = initialValue;

  // A function that increments the ID and returns the next ID
  const nextId = () => (id < Number.MAX_SAFE_INTEGER ? ++id : (id = 0));

  // Return a function that, when called, increments the ID and returns it
  return () => {
    nextId();
    return id;
  };
};
